import toastrError from 'src/helpers/toastr/toastrError';
import { wtsApi } from 'src/api';
export var LunchPolicyActions;
(function (LunchPolicyActions) {
    LunchPolicyActions["GET_LUNCH_POLICY_REQUEST"] = "GET_LUNCH_POLICY_REQUEST";
    LunchPolicyActions["GET_LUNCH_POLICY_SUCCESS"] = "GET_LUNCH_POLICY_SUCCESS";
    LunchPolicyActions["GET_LUNCH_POLICY_FAIL"] = "GET_LUNCH_POLICY_FAIL";
    LunchPolicyActions["CREATE_OR_UPDATE_LUNCH_POLICY_SUCCESS"] = "CREATE_OR_UPDATE_LUNCH_POLICY_SUCCESS";
    LunchPolicyActions["DELETE_LUNCH_POLICY_SUCCESS"] = "DELETE_LUNCH_POLICY_SUCCESS";
})(LunchPolicyActions || (LunchPolicyActions = {}));
function getLunchPolicyRequest() {
    return { type: LunchPolicyActions.GET_LUNCH_POLICY_REQUEST };
}
function getLunchPolicySuccess(payload) {
    return { type: LunchPolicyActions.GET_LUNCH_POLICY_SUCCESS, payload };
}
function getLunchPolicyFail() {
    return { type: LunchPolicyActions.GET_LUNCH_POLICY_FAIL };
}
function createOrUpdateLunchPolicySuccess(payload) {
    return { type: LunchPolicyActions.CREATE_OR_UPDATE_LUNCH_POLICY_SUCCESS, payload };
}
function deleteLunchPolicySuccess(payload) {
    return { type: LunchPolicyActions.DELETE_LUNCH_POLICY_SUCCESS, payload };
}
export function getLunchPolicy() {
    return (dispatch) => {
        dispatch(getLunchPolicyRequest());
        return wtsApi.v2.lunchPolicySearchCreate({ PageSize: -1 })
            .then(({ data }) => {
            dispatch(getLunchPolicySuccess(data));
        })
            .catch((error) => {
            dispatch(getLunchPolicyFail());
            toastrError(error);
        });
    };
}
export function createUpdateLunchPolicy(request) {
    return (dispatch) => {
        dispatch(getLunchPolicyRequest());
        return wtsApi.v2.lunchPolicyCreateUpdateCreate(request)
            .then(({ data }) => {
            dispatch(createOrUpdateLunchPolicySuccess(data));
            return data;
        })
            .catch((error) => {
            dispatch(getLunchPolicyFail());
            toastrError(error);
        });
    };
}
export function deleteLunchPolicy(Id) {
    return (dispatch) => {
        dispatch(getLunchPolicyRequest());
        return wtsApi.v2.lunchPolicyDeleteDelete({ Id })
            .then(({ data }) => {
            dispatch(deleteLunchPolicySuccess(data));
            return data;
        })
            .catch((error) => {
            dispatch(getLunchPolicyFail());
            toastrError(error);
        });
    };
}
